"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrapiClientHelper = void 0;
const qs_1 = require("qs");
const helpers_1 = require("./helpers");
class StrapiClientHelper {
    constructor(url) {
        this.url = url;
    }
    _normalizeData(data) {
        const isObject = (data) => Object.prototype.toString.call(data) === '[object Object]';
        const flatten = (data) => {
            if (!data.attributes)
                return data;
            return Object.assign({ id: data.id }, data.attributes);
        };
        if (Array.isArray(data)) {
            return data.map((item) => this._normalizeData(item));
        }
        if (isObject(data)) {
            if (Array.isArray(data.data)) {
                data = [...data.data];
            }
            else if (isObject(data.data)) {
                data = flatten(Object.assign({}, data.data));
            }
            else if (data.data === null) {
                data = null;
            }
            else {
                data = flatten(data);
            }
            for (const key in data) {
                data[key] = this._normalizeData(data[key]);
            }
            return data;
        }
        return data;
    }
    _returnDataHandler(data) {
        const response = {
            data: this._normalizeData(data.data),
            meta: data.meta,
            error: data.error,
        };
        return response;
    }
    _returnErrorHandler(err) {
        let error = {
            status: null,
            message: null,
            details: null,
            name: null,
        };
        if (err.code === 'ENOTFOUND' || err.syscall === 'getaddrinfo') {
            error.status = err.code;
            error.message = `The given url ${err.config.baseURL} is incorrect or invalid `;
            error.name = err.syscall;
        }
        else {
            if (!err.response.data.error) {
                error.status = err.response.status;
                error.message = err.response.statusText;
                error.name = err.response.data;
            }
            else {
                error = err.response.data.error;
            }
        }
        const response = {
            data: null,
            error,
        };
        return response;
    }
    _generateFilter({ field, operator, value }) {
        let rawQuery = '';
        if (Array.isArray(value)) {
            value.map((val) => {
                rawQuery += `&filters[${field}][$${operator}]=${val}`;
            });
        }
        else {
            rawQuery += `&filters[${field}][$${operator}]=${value}`;
        }
        const parsedQuery = (0, qs_1.parse)(rawQuery);
        return this._handleUrl((0, helpers_1.generateQueryString)(parsedQuery));
    }
    _genrateRelationsFilter(deepFilter) {
        let rawQuery = `filters`;
        const { path: fields, operator, value } = deepFilter;
        if (Array.isArray(fields)) {
            fields.map((field) => {
                rawQuery += `[${field}]`;
            });
        }
        const partialQuery = rawQuery;
        if (Array.isArray(value)) {
            value.map((val, index) => {
                if (index === 0) {
                    rawQuery += `[$${operator}]=${val}`;
                }
                else {
                    rawQuery += `&${partialQuery}[$${operator}]=${val}`;
                }
            });
        }
        else {
            rawQuery += `[$${operator}]=${value}`;
        }
        const parsedQuery = (0, qs_1.parse)(rawQuery);
        return this._handleUrl((0, helpers_1.generateQueryString)(parsedQuery));
    }
    _generateSort(_sort) {
        const sort = [];
        _sort.map((item) => {
            if (item.order) {
                sort.push(`${item.field}:${item.order}`);
            }
            else {
                sort.push(`${item.field}`);
            }
        });
        return this._handleUrl((0, helpers_1.generateQueryString)({ sort }));
    }
    _handleUrl(query) {
        const lastChar = this.url.charAt(this.url.length - 1);
        const hasQuerySymbol = this.url.includes('?');
        if (!hasQuerySymbol && lastChar !== '&') {
            return `${this.url}?${query}`;
        }
        else {
            return `${this.url}&${query}`;
        }
    }
    _generatePopulateDeep(options) {
        let url_string = '';
        options.map((q) => {
            const manipulatedPath = (0, helpers_1.stringToArray)(q.path);
            let partialQuery = '';
            if (Array.isArray(manipulatedPath)) {
                manipulatedPath.map((path, i) => {
                    partialQuery += i === 0 ? `populate[${path}]` : `[populate][${path}]`;
                });
            }
            if (q.fields) {
                q.fields.map((field, i) => {
                    url_string +=
                        i === 0 && url_string === ''
                            ? `${partialQuery}[fields][${i}]=${field}`
                            : `&${partialQuery}[fields][${i}]=${field}`;
                });
            }
            if (q.children === '*') {
                url_string += `&${partialQuery}[populate]=%2A`;
            }
            if (q.children && q.children !== '*') {
                const partialQuery2 = partialQuery;
                let someQuery = '';
                q.children.map((child) => {
                    if (!child.fields) {
                        url_string += `&${partialQuery2}[populate][${child.key}]=%2A`;
                    }
                    else {
                        child.fields.map((field, ind) => {
                            someQuery += `&${partialQuery2}[populate][${child.key}][fields][${ind}]=${field}`;
                        });
                    }
                    url_string += `${someQuery}`;
                });
            }
        });
        return this._handleUrl((0, qs_1.stringify)((0, qs_1.parse)(url_string)));
    }
}
exports.StrapiClientHelper = StrapiClientHelper;
